import { Component, isDevMode, OnInit } from "@angular/core";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RoleService } from "../../../../auth/service/role.service";
import { CitiesService } from "../../../../auth/service/cities.service";
import { ICity } from "app/auth/models/cities";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";

@Component({
  selector: "app-ex-employees-list",
  templateUrl: "./ex-employees-list.component.html",
  styleUrls: ["./ex-employees-list.component.scss"],
})
export class ExEmployeesListComponent implements OnInit {
  private usersList: any = [];
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public filter_figure: string = "all";
  public filter_role: string = "all";
  public filter_string: string = "";
  public filteredUsers: any = [];
  public currentUser: any = {};
  public citiesList: ICity[] = null;
  public pageNumber: number = 0;
  public availableYears: number[] = [];
  public filterYear: number = 1;
  constructor(
    public _userFigureService: UserFigureService,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
    public _utilService: UtilsService,
    private router: Router,
    private activated_route: ActivatedRoute,
    public _roleService: RoleService,
    public _citiesService: CitiesService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activated_route.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const figure = params.figure;
      const role = params.role;
      const page = params.page;

      if (!!searchKey && searchKey != 0) {
        this.filter_string = searchKey;
      }
      if (!!figure) {
        this.filter_figure = figure;
      }
      if (!!role) {
        this.filter_role = role;
      }
      if (!!page) {
        this.pageNumber = page;
      }
    });

    this.contentHeader = {
      headerTitle: "MENU.EX_EMPLOYEE_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.USERS",
            isLink: false,
          },
          {
            name: "MENU.EX_EMPLOYEE_LIST",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.citiesList = await this._citiesService.getList();
    await this.loadList();
  }

  async loadList() {
    if (!this._authenticationService.hasCapability(`show_menu_ex-employee_list`)) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.currentUser = this._authenticationService.getCurrentUser();
    await this._userService.getExEmployees().then(async (r) => {
      this.usersList = r;
      if (this.usersList && this.usersList.length > 0) {
        this.usersList.map((user) => {
          if (!!user.contract_closed_at) {
            const year = moment(user.contract_closed_at).year();
            if (!this.availableYears.includes(year)) {
              this.availableYears.push(year);
            }
          }
        });
      }

      this.getItems();
    });
    this._utilService.hideLoading();
  }

  async reloadExEmployee() {
    if (this.filterYear > 1) {
      this.usersList = await this._userService.getExEmployees(this.filterYear);
    } else {
      this.usersList = await this._userService.getExEmployees();
    }
    this.getItems();
  }

  getItems() {
    let filteredItems: any = this.usersList.sort((a, b) => (a.lastname > b.lastname ? 1 : -1));
    const keyword: string = String(this.filter_string).toLowerCase();
    if (keyword.length > 1) {
      filteredItems = filteredItems.filter(
        (item: any) =>
          item.complete_name.toLowerCase().includes(keyword) ||
          String(item.figure || "")
            .toLowerCase()
            .includes(keyword) ||
          (item.working_city || "").toLowerCase().includes(keyword) ||
          item.number.toLowerCase().includes(keyword) ||
          item.hash === keyword,
      );
    }

    if (this.filter_figure && this.filter_figure.length > 0 && this.filter_figure !== "all") {
      filteredItems = filteredItems.filter((item: any) => item.figure === this.filter_figure);
    }
    if (this.filter_role && this.filter_role.length > 0 && this.filter_role !== "all") {
      filteredItems = filteredItems.filter((item: any) => item.role === this.filter_role);
    }

    filteredItems = filteredItems.map((item: any) => {
      item.end_date = item.contract_closed_at || item.contract_end_date;
      return item;
    });

    this.filteredUsers = filteredItems;
    this.filter_figure = this.filter_figure === "all" ? null : this.filter_figure;
    this.filter_role = this.filter_role === "all" ? null : this.filter_role;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.filter_string && this.filter_string.length >= 3) {
      url.searchParams.set("search", this.filter_string);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_figure && this.filter_figure.length > 0 && this.filter_figure !== "all") {
      url.searchParams.set("figure", this.filter_figure);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("figure");
      history.pushState({}, "", url);
    }

    if (this.filter_role && this.filter_role.length > 0 && this.filter_role !== "all") {
      url.searchParams.set("role", this.filter_role);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("role");
      history.pushState({}, "", url);
    }
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  setPage(pageInfo: any) {
    this.pageNumber = pageInfo.offset;
    const url = new URL(window.location.href);

    if (!!this.pageNumber && this.pageNumber >= 1) {
      url.searchParams.set("page", String(this.pageNumber));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("page");
      history.pushState({}, "", url);
    }
  }

  async deleteUser(hash: string) {
    if (!this._authenticationService.hasCapability("delete_user")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (isDevMode()) {
      //Possibilità di eliminare un utente soltanto in deve mode
      await this._utilService
        .showSWAL({
          title: "CONFIRM_DELETE_TITLE",
          text: "CONFIRM_DELETE_USER_TEXT",
          icon: "warning",
          confirmButtonText: "CONFIRM_DELETE_BTN",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        })
        .then(async (result) => {
          if (result.value) {
            await this._userService.delete(hash).then(async () => {
              await this._utilService.showPopupItemDeleted("DELETED_USER_TEXT").then(() => window.location.reload());
            });
          }
        });
    } else {
      return false;
    }
  }

  async export() {
    let fullData: any = this.usersList;
    if (!!fullData && fullData.length > 0) {
      const keyword: string = String(this.filter_string).toLowerCase();
      if (keyword.length > 1) {
        fullData = fullData.filter((item: any) => item.firstname.toLowerCase().includes(keyword) || item.lastname.toLowerCase().includes(keyword) || item.email.includes(keyword));
      }

      return this._utilService.exportAsExcelFile(
        fullData.map((user: any) => {
          const city = !!user.addresses ? this.citiesList.find((el) => el.id === user.addresses[0]?.city) : {} as ICity;
          const province = !!user.addresses ? this.citiesList.find((el) => el.id === user.addresses[0]?.province) : {} as ICity;
          return {
            "Cognome e Nome": `${user.lastname} ${user.firstname}`,
            "Nome": user.firstname,
            "Cognome": user.lastname,
            "Email": user.private_email,
            "Telefono": user.private_phone,
            "Indirizzo di residenza": user.addresses && user.addresses.length > 0 ? `${user.addresses[0].street} ${user.addresses[0].zipcode} ${city.name} ${province.name}` : "/",
            "Matricola": user.badge_number,
            "Figura": user.figure,
            "Sede di lavoro": user.working_city,
            "Data di assunzione": moment(user.contract_start_date).format('DD/MM/YYYY'),
            "Data cessazione contratto": moment(user.contract_closed_at || user.contract_end_date).format('DD/MM/YYYY'),
            "Qualifica": user.classification || '',
            "Tipologia Rapporto di Lavoro": user.contract_type || '',
          };
        }),
        "export-users-" + "ex-employee",
      );
    }
  }
}
